// src/ReportList.js
import React, { useState, useEffect } from 'react';

const API_BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:7071' 
  : ''; // Use relative paths for the deployed app

function ReportList() {
    const [reports, setReports] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchReports = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/reports`);
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to fetch reports: ${errorText} (Status: ${response.status})`);
                }
                const data = await response.json();
                
                // Slice the array to get only the first 5 most recent reports
                const recentReports = (data || []).slice(0, 5);
                
                setReports(recentReports);
            } catch (e) {
                setError(e.message);
                console.error("Failed to fetch reports:", e);
            } finally {
                setIsLoading(false);
            }
        };

        fetchReports();
    }, []);

    const handleDownload = (filename) => {
        const downloadUrl = `${API_BASE_URL}/api/report/download?filename=${encodeURIComponent(filename)}`;
        window.open(downloadUrl, '_blank');
    };

    // Helper function to extract just the filename from the full blob path
    const getCleanFilename = (fullPath) => {
        return fullPath.split('/').pop();
    }

    if (isLoading) return <p>Loading reports...</p>;
    if (error) return <p className="error">Could not load reports: {error}</p>;

    return (
        <div className="report-list">
            <h3>Recent Reports</h3>
            {reports.length > 0 ? (
                <table>
                    <thead>
                        <tr>
                            <th>Report Name</th>
                            <th>Created On (UTC)</th>
                            <th>Size</th>
                            <th>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reports.map(report => (
                            <tr key={report.name}>
                                {/* Use the helper function to show a clean name */}
                                <td>{getCleanFilename(report.name)}</td>
                                <td>{report.last_modified.replace('T', ' ').substring(0, 19)}</td>
                                <td>{Math.round(report.size_bytes / 1024)} KB</td>
                                <td>
                                    <button onClick={() => handleDownload(report.name)}>
                                        Download
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No reports found.</p>
            )}
        </div>
    );
}

export default ReportList;